import * as React from 'react';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';

export interface SetAsReceivedMenuItemProps {
    id: string;
    onComplete: () => void;
}

export const SetAsReceivedMenuItem = (props: SetAsReceivedMenuItemProps) => {
    const client = useWebPortalApiClient();

    const setAsReceived = async () => {
        const patchResult = await client.client.patchCoughSession({
            postalReceived: new Date().toISOString()
        }, props.id, "");

        if (patchResult.postalReceived)
            props.onComplete();
    }

    return (
        <li>
            <a onClick={() => setAsReceived()}>Set as Received</a>
        </li>
    );
}
